export default __webpack_public_path__ + "static/media/Rectangle319.a2dba55d.svg";